/**
 * [after], an edit a page made to [before], made again on [current] — the
 * list as the file holds it now, which a device may have re-saved since the
 * page read it. What the edit added, changed or took out is applied, in the
 * page's order; anything it left alone is as [current] has it, so an entry
 * another device added or changed meanwhile stays.
 */
export function rebased<T>(
  current: readonly T[],
  before: readonly T[],
  after: readonly T[],
  key: (item: T) => string,
  line: (item: T) => string,
): T[] {
  const was = new Map(before.map((item) => [key(item), item]));
  const now = new Map(current.map((item) => [key(item), item]));
  const out: T[] = [];
  for (const item of after) {
    const prior = was.get(key(item));
    if (prior === undefined || line(prior) !== line(item)) {
      out.push(item);
      continue;
    }
    const fresh = now.get(key(item));
    if (fresh !== undefined) out.push(fresh);
  }
  const placed = new Set(after.map(key));
  for (const item of current) {
    if (!placed.has(key(item)) && !was.has(key(item))) out.push(item);
  }
  return out;
}
